import React, { useContext } from 'react'
import { EPCRContext } from '../../EPCR'
import { FormControlLabel, Switch } from '@mui/material'

const HSOrgNotified = () => {
  const { formValues, handleChange } = useContext(EPCRContext)
  return (
    <FormControlLabel
      label="Event Organiser / Control Notified about this incident?"
      control={
        <Switch
          checked={formValues?.incident?.healthSafetyEventOrganiserNotified}
          onChange={(e) =>
            handleChange({
              moduleName: 'incident',
              field: 'healthSafetyEventOrganiserNotified',
              value: e.target.checked,
            })
          }
        />
      }
    />
  )
}

export default HSOrgNotified
